import { useEffect } from "react";

import {
  EditUI,
  selectEditMode,
  setEditMode,
  toggleEditMode,
  toggleUserSettingsPanelOpen,
} from "@/features/app/appSlice";
import { selectConfigItem } from "@/features/config/configSlice";

import { useAppDispatch, useAppSelector } from ".";

const useKeyboardListener = () => {
  const dashboardEmbed = useAppSelector(
    selectConfigItem("internal.dashboardEmbed"),
  );
  const dispatch = useAppDispatch();
  const currentEditMode = useAppSelector(selectEditMode);

  useEffect(() => {
    const safeToggleEditMode = (editMode: EditUI | "user_settings") => {
      if (editMode == "user_settings") {
        if (dashboardEmbed) {
          return;
        } else {
          dispatch(toggleUserSettingsPanelOpen());
        }
      } else {
        if (dashboardEmbed) {
          dispatch(setEditMode(editMode));
        } else {
          dispatch(toggleEditMode(editMode));
        }
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === ",") {
        safeToggleEditMode(EditUI.settings);
      } else if (event.ctrlKey && event.key === "n") {
        safeToggleEditMode(EditUI.overlayLayers);
      } else if (event.ctrlKey && event.key === "m") {
        safeToggleEditMode(EditUI.paths);
      } else if (event.ctrlKey && event.key === "'") {
        safeToggleEditMode("user_settings");
      } else if (event.ctrlKey && event.key === ".") {
        safeToggleEditMode(EditUI.baseLayers);
      }
    };

    // Attach the event listener
    document.addEventListener("keydown", handleKeyDown);

    // // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentEditMode]);
};

export default useKeyboardListener;
